// components/ui/Input.jsx
import React from 'react'
import { cn } from '../../lib/cn'

export function Input({
  label,
  error,
  helperText,
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  className = '',
  ...props
}) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-semibold text-slate-700 mb-2">
          {label}
        </label>
      )}

      <div className="relative">
        {LeftIcon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
            <LeftIcon className="h-4 w-4" />
          </div>
        )}

        <input
          className={cn(
            'w-full rounded-lg border bg-white px-4 py-2.5 text-sm text-slate-900',
            'placeholder:text-slate-400',
            'transition-all duration-200',
            'focus:outline-none focus:ring-4',
            error
              ? 'border-red-300 focus:border-red-500 focus:ring-red-100'
              : 'border-slate-200 focus:border-purple-300 focus:ring-purple-100',
            LeftIcon && 'pl-10',
            RightIcon && 'pr-10',
            props.disabled && 'opacity-50 cursor-not-allowed bg-slate-50',
            className
          )}
          {...props}
        />

        {RightIcon && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400">
            <RightIcon className="h-4 w-4" />
          </div>
        )}
      </div>

      {error && (
        <p className="mt-1.5 text-xs text-red-600">{error}</p>
      )}

      {!error && helperText && (
        <p className="mt-1.5 text-xs text-slate-500">{helperText}</p>
      )}
    </div>
  )
}

export function Textarea({
  label,
  error,
  helperText,
  className = '',
  ...props
}) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-semibold text-slate-700 mb-2">
          {label}
        </label>
      )}

      <textarea
        className={cn(
          'w-full rounded-lg border bg-white px-4 py-2.5 text-sm text-slate-900',
          'placeholder:text-slate-400',
          'transition-all duration-200',
          'focus:outline-none focus:ring-4',
          error
            ? 'border-red-300 focus:border-red-500 focus:ring-red-100'
            : 'border-slate-200 focus:border-purple-300 focus:ring-purple-100',
          props.disabled && 'opacity-50 cursor-not-allowed bg-slate-50',
          className
        )}
        {...props}
      />

      {error && (
        <p className="mt-1.5 text-xs text-red-600">{error}</p>
      )}

      {!error && helperText && (
        <p className="mt-1.5 text-xs text-slate-500">{helperText}</p>
      )}
    </div>
  )
}
